import { createContext, useContext } from 'react';

export interface NewAuthDialogState {
    open: boolean;
    setOpen: (state: boolean) => void;
    onEnd?: () => void;
    setOnEnd?: (state: () => void) => void;
    fromCartCheckout: boolean;
    cartItems?: any;
    totalAmount?: any;
}

export const NewAuthDialogContext = createContext<NewAuthDialogState>({
    open: false,
    fromCartCheckout: false,
    setOpen: () => void 0,
    onEnd: () => void 0,
    setOnEnd: () => void 0,
    cartItems: () => void 0,
    totalAmount: () => void 0,
});

export const useNewAuthDialog = () => useContext(NewAuthDialogContext);
